const siteName = process.env.siteName

export const getSiteName = () => siteName

export const getDifferentSiteNameInList = (siteList, defaultName = 'common') => {
  const siteIndex = siteList.indexOf(siteName)
  return siteIndex === -1 ? defaultName : siteList[siteIndex]
}



// WEBPACK FOOTER //
// ./src/common/js/siteUtil.js